import { useTranslation } from 'react-i18next';
import verifySvg from "../../assets/images/verify.avif";
import SlideUp from "./SlideUp";
import {downloadSvg} from "../../constants/data";

const LeftRight = ({
                     title,
                     titleClass= 'text-gray-900 ',
                     isLeft = true, // Controls whether text is left or right
                     sectionClass = 'pb-24',
                     textPosition = 'justify-center',
                     descriptionPosition = 'text-left',
                     textWidthClass = 'md:w-1/2', // Set default to 0 or whatever you prefer
                     subtitle,
                     descriptionList = [],
                     descriptionListPrefix = '',
                     listGroup = [],
                     secondListGroup = [],
                     icon = true,
                     image,
                     imageHoverable = false,
                     imgClass = false,
                     downloadBtn = false,
                     downloadLink = '',
                   }) => {
  const { t } = useTranslation();
  return (
    <SlideUp>
      <section className={`w-full ${sectionClass} overflow-hidden`}>
        {title && (
          <h2 className={`text-center flex items-center justify-center ${titleClass} md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
            {title}
          </h2>
        )}
        <div
          className={`w-full bg-pink-4000 flex flex-col md:flex-row gap-10 
            ${isLeft ? 'md:flex-row' : 'md:flex-row-reverse'}
          `}
        >
          {/* Text Block */}
          <div className={`${textWidthClass} flex flex-col ${textPosition} bg-violet-9500`}>
            {subtitle && (
              <h3 className={`text-lg md:text-lg text-gray-900 theme-font-bold ${icon?'ms-10':''} mb-3 ${descriptionPosition}`}>
                {subtitle}
              </h3>
            )}
            <div className={``}>
              {descriptionList && descriptionList.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start justify-start mb-5 gap-3"
                >
                  {icon && (
                    <img
                      src={verifySvg}
                      alt="icon"
                      className="w-[30px] h-[30px]"
                    />
                  )}
                  <div>
                    <p className={`md:text-xl text-gray-700 leading-relaxed ${descriptionPosition}`}>
                      {
                        descriptionListPrefix === '' ? item
                          :
                        t(`${descriptionListPrefix+'.'+item}`)
                      }
                    </p>
                    {downloadBtn && (
                      <a
                        rel="noreferrer"
                        target={'_blank'}
                        href={downloadLink}
                        className="w-[120px] text-base mt-8 h-10 rounded-lg bg-theme-color text-white text-center flex items-center justify-center"
                        dir="auto"
                      >
                        {downloadSvg}&nbsp;{t('common.download')}
                      </a>
                    )}

                  </div>
                </div>
              ))}
            </div>
            {listGroup && (
              <div className="flex flex-col items-start justify-start mt-4">
                {listGroup.map((item, index) => (
                  <div
                    key={index}
                    className="flex mb-2"
                  >
                    <div className="mr-2">-</div>
                    <div className="text-gray-700 md:text-xl leading-relaxed ">
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Image Block */}
          <div className="flex-1 w-full bg-cyan-4000">
            {image && !imageHoverable && (
              <div className={imgClass ? `${imgClass}` : 'w-full'}>
                <img
                  src={image}
                  alt={subtitle}
                  className="mx-auto float-bounceee"
                />
              </div>
            )}
            {image && imageHoverable && (
              <div className={imgClass || 'w-full rounded-3xl overflow-hidden group relative'}>
                <img
                  src={image}
                  alt={subtitle}
                  className="w-full h-full mx-auto object-cover transition-all duration-500 group-hover:scale-110 group-hover:rotate-1"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl"></div>
              </div>
            )}
            {/* Second List Group */}
            {secondListGroup && (
              <div className="flex flex-col items-start justify-start mt-4">
                {secondListGroup.map((item, index) => (
                  <div
                    key={index}
                    className="flex mb-2"
                  >
                    <div className="mr-2">-</div>
                    <div className="text-gray-700 md:text-xl">
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </SlideUp>
  );
};

export default LeftRight;
